export default "__VITE_ASSET__9cc004b0__"